import { FC } from "react";

import { EditRecordForm } from "../../components/EditRecordForm";

const EditRecordPage: FC = () => {
  return <EditRecordForm />;
};

export default EditRecordPage;
